import { FC, useContext } from "react";
import { ProviderHubContext } from "@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext";
import { getCriticalityClass, getCriticalityLabel } from "@app/projects/network-assessment/provider-hub/utility";
import InfoIndicator from "@app/shared/InfoIndicator";

const criticalityTooltipContent = (
  <div className="provider-profile__card-title-tooltip text-start">
    <p>
      A provider&apos;s criticality score is calculated at the specialty/county level. Each component is scored
      independently, then combined into a total score of 10. The score contains three components:
    </p>
    <ul>
      <li>Geographic Criticality - What proportion of members does this provider cover in the service area?</li>
      <li>Specialty Criticality - How essential is this provider for covering a specialty?</li>
      <li>Scarcity Criticality - How scarce are alternative provider options in the region?</li>
    </ul>
  </div>
);

const ProviderProfileCriticality: FC = () => {
  const { adequacyProviderScore } = useContext(ProviderHubContext);

  return (
    <div className="provider-profile__card">
      <h4 className="provider-profile__card-title">
        Criticality
        <InfoIndicator
          className="provider-profile__card-title-info"
          tooltipPlacement="bottom"
          tooltipTitle={criticalityTooltipContent}
          tooltipWidth="320px"
        />
      </h4>
      <div className="provider-profile__card-content">
        <div className="provider-profile__card-values">
          <div
            className={`provider-profile__card-highlight ${getCriticalityClass(adequacyProviderScore)}`}
            aria-labelledby="adequacy-criticality"
          >
            {getCriticalityLabel(adequacyProviderScore)}
          </div>
        </div>
        <div className="provider-profile__card-labels">
          <div className="provider-profile__card-subtitle" id="adequacy-criticality">Adequacy Criticality</div>
        </div>
      </div>
    </div>
  );
};

export default ProviderProfileCriticality;
